"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastNMonths = void 0;
var dateTime_1 = require("utils/dateTime");
var getLastNMonths = function (n) { return (0, dateTime_1.getLastNMonthDates)(n)
    .map(function (date) { return ({ month: date.getMonth() + 1, year: date.getFullYear() }); }); };
exports.getLastNMonths = getLastNMonths;
